export const tagVariant = (tag: string) => {
  switch (tag) {
    case 'engage':
      return 'error';
    case 'calendar':
      return 'info';
    case 'suggestion':
      return 'success';
    default:
      return 'default';
  }
};
